import { useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { COLUMNS } from "../constants/columns";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Button,
  Col,
  Input,
  Label,
  Row,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
} from "reactstrap";
import { Select } from "../../../components/Inputs/Input";
import * as actions from "../../../store/modules/feriados/actions";
import * as feriadosController from "../../../controllers/feriadosController";
import * as BsIcons from "react-icons/bs";
import * as BiIcons from "react-icons/bi";
import ReactPaginate from "react-paginate";

const Search = () => {
  const { allItems, pesquisa, items, permitions, nacional } = useSelector(
    (state) => {
      return state.feriado;
    }
  );
  const columns = useMemo(() => COLUMNS, []);
  const data = items;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    state,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { pageSize } = state;
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [modalDelete, setModalDelete] = useState(false);
  const [itemSelected, setItem] = useState(null);

  function onChange(value, field) {
    const finalValue =
      field === "nacional" ? (value === null ? null : Boolean(value)) : value;

    actions.pesquisar({ ...pesquisa, [field]: finalValue });
  }
  const handlePageClick = (e) => {
    const pageSelected = e.selected;
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);

    feriadosController.getFeriados(pageSelected + 1, pageSize, pesquisa);
  };
  async function handleUpdate(id) {
    await feriadosController.getById(id);
    actions.setActiveTab("Register");
  }

  function handleInitialPage(newPageSize) {
    const pageSelected = 0;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    actions.setSelectedItems([]);
    gotoPage(pageSelected);
    feriadosController.getFeriados(pageSelected + 1, newPageSize, pesquisa);
  }
  function handleDelete(id) {
    setItem(id);
    toggleModalDelete();
    actions.setSelectedItems([]);
  }
  function toggleModalDelete() {
    setModalDelete(!modalDelete);
  }
  function deleteFeriado() {
    feriadosController.deleteFeriado(itemSelected);
  }

  function handleSearch() {
    const cleanFilters = Object.fromEntries(
      Object.entries(pesquisa).filter(([_, v]) => v !== null && v !== "")
    );
    feriadosController.getFeriados(1, pageSize, cleanFilters);
    setSelectedPage(0);
    gotoPage(0);
  }

  return (
    <>
      <Modal
        className="text-center"
        isOpen={modalDelete}
        toggle={toggleModalDelete}
        backdrop={false}
      >
        <ModalHeader
          toggle={toggleModalDelete}
          style={{ height: "10px", border: "none" }}
        />
        <ModalBody>
          <p style={{ fontSize: "18px", color: "var(--color-preto)" }}>
            Tem certeza que deseja{" "}
            <strong style={{ fontSize: "17px" }}>remover</strong> esse item?
          </p>
        </ModalBody>
        <div className="m-3">
          <Button
            onClick={() => toggleModalDelete()}
            color="danger"
            style={{ width: "100px", marginRight: "15px" }}
          >
            {" "}
            Cancelar{" "}
          </Button>
          <Button
            onClick={() => {
              deleteFeriado();
              toggleModalDelete();
            }}
            style={{
              width: "100px",
              marginLeft: "15px",
              background: "var(--color-verde)",
              border: "none",
            }}
          >
            {" "}
            Confirmar{" "}
          </Button>
        </div>
      </Modal>
      <Col>
        <Card
          className="p-4 mb-5"
          style={{
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <div style={{ width: "25%" }} className="pb-3">
            <Label
              style={{
                fontWeight: "400",
                fontSize: "18px",
                margin: "5px 0 8px 15px",
              }}
            >
              Pesquisar
            </Label>
          </div>
          <Form style={{ margin: "0px 0px 15px 15px" }}>
            <Row>
              <Col md={3}>
                <FormGroup>
                  <Label>Nome Do Feriado:</Label>
                  <Input
                    type="text"
                    placeholder="Digite aqui..."
                    value={pesquisa.descricao}
                    onChange={(e) => onChange(e.target.value, "descricao")}
                    style={{ height: "35px" }}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Label>Feriado Nacional:</Label>
                  <Select
                    first="SELECIONE"
                    options={nacional}
                    value={nacional.find(
                      (opt) => opt.value === pesquisa.nacional
                    )}
                    onChange={(e) => onChange(e.value, "nacional")}
                    isSearchable={true}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "35px",
                        height: "35px",
                      }),
                    }}
                  />
                </FormGroup>
              </Col>

              <Col md={3}>
                <FormGroup>
                  <Label style={{ fontWeight: "300" }}>Data:</Label>
                  <Input
                    style={{ maxWidth: "500px" }}
                    type="date"
                    value={pesquisa.data}
                    max="9999-12-31"
                    onChange={(e) => onChange(e.target.value, "data")}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row style={{ paddingTop: "30px" }}>
              <Col>
                <Button
                  className="mr-4"
                  style={{
                    width: "150px",
                    background: "var(--color-branco)",
                    borderColor: "var(--color-laranja)",
                    color: "var(--color-laranja)",
                    borderRadius: "7px",
                    marginTop: "30",
                  }}
                  onClick={actions.cleanSearch}
                >
                  Limpar
                </Button>
                <Button
                  className="purpleButton"
                  style={{ width: "150px" }}
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Buscar
                </Button>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              width: "95%",
              overflow: `auto`,
              maxHeight: "700px",
              // minWidth: "1400px",
              padding: "10px",
            }}
          >
            <table className="custom-table" {...getTableProps()}>
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th >
                        {column.render("Header")}
                        <span className="float-right">
                          {column.isSorted ? (
                            column.isSortedDesc ? (
                              <BsIcons.BsArrowDown
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps({
                                    title: undefined,
                                  })
                                )}
                              />
                            ) : (
                              <BsIcons.BsArrowUp
                                id="OrdenarAsc"
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps({
                                    title: undefined,
                                  })
                                )}
                              />
                            )
                          ) : (
                            <BsIcons.BsArrowDownUp
                              {...column.getHeaderProps(
                                column.getSortByToggleProps({
                                  title: undefined,
                                })
                              )}
                            />
                          )}
                        </span>
                      </th>
                    ))}
                    <th style={{ minWidth: "150px" }}>Ações</th>
                  </tr>
                ))}
              </thead>
              <tbody
                {...getTableBodyProps()}
                style={{ textAlign: "left", padding: "20px" }}
              >
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr className="text-center" {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            style={{ minWidth: "150px", textAlign: "left" }}
                          >
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                      <td style={{ minWidth: "150px" }}>
                        <>
                          {permitions.criar && (
                            <BiIcons.BiEdit
                              style={{
                                fontSize: "1.2rem",
                                cursor: "pointer",
                                color: "#C4C7CA",
                                marginRight: "7px",
                              }}
                              onClick={() => handleUpdate(row.original.id)}
                            />
                          )}
                          {permitions.deletar && (
                            <BiIcons.BiTrash
                              style={{
                                fontSize: "1.2rem",
                                cursor: "pointer",
                                color: "#C4C7CA",
                              }}
                              onClick={() => handleDelete(row.original.id)}
                            />
                          )}
                        </>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Row className="pt-4">
            <Col>
              <span style={{ color: "var(--color-cinza-medio)" }}>
                Mostrando{" "}
                {allItems.quantidade !== undefined ? allItems.quantidade : "0"}{" "}
                de{" "}
                {allItems.quantidadeTotal !== undefined
                  ? allItems.quantidadeTotal
                  : "0"}
              </span>
            </Col>
            <Col md={8}>
              <Row className="float-right">
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  initialPage={0}
                  pageCount={allItems.totalPaginas}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handlePageClick(e)}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                  forcePage={initialPage ? 0 : selectedPage}
                />
                <Input
                  type="select"
                  className="pageSize"
                  value={pageSize}
                  onChange={(e) => {
                    const newPageSize = Number(e.target.value);
                    handleInitialPage(newPageSize);
                    setPageSize(newPageSize);
                  }}
                >
                  {[10, 25, 100].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </Input>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </>
  );
};

export default Search;
